// modules
import { addModal } from 'weblite-web-modal-viewer'
// component
import { ProfilePictureMenu } from './profile-picture'

const COMPONENT_ID = 'profilePictureMenu'

interface Prop {
  onSubmit: (fileId: string | undefined) => unknown
  showDelete: boolean
}

export const showProfilePictureMenu = (props: Prop, preventBackClick = false) =>
  addModal({ id: COMPONENT_ID, props, preventBackClick })

export default {
  [COMPONENT_ID]: { Component: ProfilePictureMenu },
}
